export const formatEur = (n) => {
    if (n === null || n === undefined || isNaN(n)) return "—";
    return new Intl.NumberFormat("en-EU", {
        style: "currency",
        currency: "EUR",
        maximumFractionDigits: 0,
    }).format(n);
};

export const formatNumber = (n, digits = 0) => {
    if (n === null || n === undefined || isNaN(n)) return "—";
    return new Intl.NumberFormat("en-EU", {
        maximumFractionDigits: digits,
        minimumFractionDigits: digits,
    }).format(n);
};

export const formatPct = (n, digits = 1) => {
    if (n === null || n === undefined || isNaN(n)) return "—";
    return `${formatNumber(n, digits)}%`;
};

export const formatDate = (iso) => {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        return d.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    } catch {
        return "—";
    }
};

export const formatDateTime = (iso) => {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        return d.toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return "—";
    }
};

export const flipLabelColor = (label) => {
    const map = {
        "Exceptional Flip Candidate": "deep-green",
        "Strong Candidate": "champagne",
        "Needs Deeper Due Diligence": "orange",
        "Weak Candidate": "muted",
        Avoid: "destructive",
    };
    return map[label] || "muted";
};
